import React from 'react'

type Props = { children: React.ReactNode }
type State = { error: Error | null }

export default class AppErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: any) {
    // Keep this lightweight; route-level errors should use errorElement.
    console.error('AppErrorBoundary', error, info)
  }

  render() {
    if (!this.state.error) return this.props.children
    const msg = this.state.error?.message || 'Unexpected error'
    return (
      <div className="min-h-screen bg-zinc-950 text-white px-6 py-10">
        <div className="mx-auto max-w-xl">
          <div className="text-2xl font-extrabold">Something went wrong</div>
          <div className="mt-2 text-white/70 text-sm">
            The app hit an error while rendering this page. You can refresh, or go back to Settings.
          </div>
          <div className="mt-4 rounded-xl border border-white/10 bg-white/5 p-4 text-sm text-white/80">
            {msg}
          </div>
          <div className="mt-5 flex flex-wrap gap-2">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="inline-flex items-center justify-center rounded-lg px-3 py-2 text-sm font-semibold transition border bg-sky-600 text-white border-sky-500/40 hover:bg-sky-500 hover:border-sky-400/50"
            >
              Refresh
            </button>
            <button
              type="button"
              onClick={() => window.location.assign('/settings')}
              className="inline-flex items-center justify-center rounded-lg px-3 py-2 text-sm font-semibold transition border bg-white/10 text-white border-white/15 hover:bg-white/15"
            >
              Go to Settings
            </button>
          </div>
        </div>
      </div>
    )
  }
}

